import {Box, styled} from '@mui/material';
import {OtherServicesContainerProps} from './types';

export const OtherServicesContainer = styled(Box)<OtherServicesContainerProps>`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(310px, 1fr));
	max-width: 1280px;
	gap: 16px;

	${({theme, $sidebarIsOpen}) =>
		theme.breakpoints.between($sidebarIsOpen ? 988 : 795, $sidebarIsOpen ? 1329 : 1121)} {
		& > :nth-of-type(2) {
			order: 4;
		}
	}

	${({theme}) => theme.breakpoints.between(700, 'md')} {
		& > :nth-of-type(2) {
			order: 4;
		}
	}
`;
